import { Component } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'

import { SalesPeriodsService } from '@/services/sales-periods.service'

import { TranslateService } from '@ngx-translate/core'

@UntilDestroy()
@Component({
  selector: 'current-sales-periods',
  template: `
    <div class="mt-4">
      <sales-period-list [salesPeriods]="periods.current$|async" [title]="title"></sales-period-list>
    </div>
  `
})
export class CurrentSalesPeriodsViewComponent {

  constructor(
    private _translate: TranslateService,
    public periods: SalesPeriodsService
  ) { }

  get title(): string {
    return this._translate.instant('pricing.title.active')
  }
}
